import { Navigate, useLocation } from "react-router-dom";
import { useToast, useProfileRole, useRoutesRole } from "../helpers/hooks";
import { UserProps } from "../interfaces";
export const ProtectedRoute = ({ user, children, dealership }: { user: UserProps | null, children: JSX.Element, dealership: any }) => {
	const toast = useToast();
	let location = useLocation();
	const profileRole = useProfileRole();
	const routesRole = useRoutesRole();
	const userRole = profileRole(user?.profile?.code);

	if (!user) {
		toast("Debes iniciar sesión");
		return <Navigate to="/" state={{ from: location }} replace />;
	}else{
		if(routesRole(location.pathname, userRole) === "admin" && dealership?.type === "new"){
			return <Navigate to="/profile/leads" replace />;
		}
		if(routesRole(location.pathname, userRole) === "admin"){
			return <Navigate to="/profile/leads" replace />;
		}
		if(routesRole(location.pathname, userRole) !== ""){
			return <Navigate to="/profile/leads" replace />;
		}
	}
	return children;
};